import { render, staticRenderFns } from "./container_demand.vue?vue&type=template&id=10ce28d6&scoped=true&"
import script from "./container_demand.vue?vue&type=script&lang=js&"
export * from "./container_demand.vue?vue&type=script&lang=js&"
import style0 from "./container_demand.vue?vue&type=style&index=0&id=10ce28d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce28d6",
  null
  
)

export default component.exports